/** Unique ids for local-only entities (avoid Date.now() collisions in rapid AI batch creates). */

export function generateLocalEntityId(prefix = 'loc') {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * OpenAPI / Brevo-style `{param}` → Apiboo `{{param}}` (skips already-doubled braces).
 */
export function normalizeSingleBraceVariables(text) {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/(?<!\{)\{([a-zA-Z_][a-zA-Z0-9_.-]*)\}(?!\})/g, '{{$1}}');
}

export function normalizeRequestVariables(request) {
  if (!request) return request;
  return {
    ...request,
    url: normalizeSingleBraceVariables(request.url),
    headers: (request.headers || []).map((h) => ({
      ...h,
      key: normalizeSingleBraceVariables(h.key),
      value: normalizeSingleBraceVariables(h.value),
    })),
    params: (request.params || []).map((p) => ({
      ...p,
      key: normalizeSingleBraceVariables(p.key),
      value: normalizeSingleBraceVariables(p.value),
    })),
  };
}

function requestNeedsNormalize(req) {
  const n = normalizeRequestVariables(req);
  return n.url !== req.url
    || JSON.stringify(n.headers) !== JSON.stringify(req.headers)
    || JSON.stringify(n.params) !== JSON.stringify(req.params);
}

/** Reassign duplicate request ids (e.g. after fast AI batch used Date.now()). */
export function dedupeCollectionRequestIds(collections) {
  const seen = new Set();
  let changed = false;

  const next = (collections || []).map((col) => {
    const requests = (col.requests || []).map((req) => {
      let nextReq = req;
      let id = String(nextReq.id);

      if (seen.has(id)) {
        nextReq = { ...nextReq, id: generateLocalEntityId('req') };
        id = String(nextReq.id);
        changed = true;
      }
      seen.add(id);

      if (requestNeedsNormalize(nextReq)) {
        nextReq = normalizeRequestVariables(nextReq);
        changed = true;
      }

      return nextReq;
    });
    return { ...col, requests };
  });

  return changed ? next : collections;
}
